import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuoteModel } from 'src/app/models/quote.model';

@Component({
  selector: 'app-quote-option',
  templateUrl: './quote-option.component.html',
  styleUrls: ['./quote-option.component.scss'],
})
export class QuoteOptionComponent implements OnInit {

  @Input() quote: QuoteModel;
  @Input() premium: number;
  @Input() enableEdit = false;
  @Output() select = new EventEmitter<QuoteModel>();
  @Output() edit = new EventEmitter<QuoteModel>();

  policyType: string;
  singleOrDual: string;
  term: string;
  coverBasis: string;
  sumAssured: number;

  constructor(
  ) { }

  ngOnInit() {
    const answersObject = this.quote.answers.toDictionary(x => x.key, x => x.value);
    this.sumAssured = parseInt(answersObject[`ProtectionLevel_2`]);
    this.coverBasis = answersObject[`CoverBasis_2`];
    this.singleOrDual = answersObject[`TypeOfPolicy_2`];
    this.term = answersObject[`PolicyTerm_2`];
    this.policyType = answersObject[`PolicyType_2`];
  }
}
